import ContactUsBanner from "../components/ContactUs/ContactUsBanner";
import ContactForm from "../components/ContactUs/ContactUsForm";
export default function ContactUsPage() {
  return (
    <>
      <ContactUsBanner />
      <ContactForm />
    </>
  );
}
